import './mobileStyles.scss';

// CSS class name mapping — replaces withStyles(EmployeeDashboardMobileStyles).
const MOBILE_CLASSES = {
    drawerFullHeight: 'mob-drawer-full-height', closeButton: 'mob-close-button',
    monthSelectorBar: 'mob-month-selector-bar', fullPage: 'mob-full-page',
    horizontalCentered: 'mob-horizontal-centered',
    calendarHeader: 'mob-calendar-header', calendarRow: 'mob-calendar-row',
    calendarHeaderField: 'mob-calendar-header-field',
    emptyCalendarDayCell: 'mob-empty-calendar-day-cell',
    calendarDayCell: 'mob-calendar-day-cell',
    calendarDayCellOtherMonth: 'mob-calendar-day-cell-other-month',
    calendarDayCellDate: 'mob-calendar-day-cell-date',
    calendarDayCellDots: 'mob-calendar-day-cell-dots',
    calendarDayCellBoxes: 'mob-calendar-day-cell-boxes',
    shiftsDot: 'mob-shifts-dot', paycodesDot: 'mob-paycodes-dot',
    dayCellLongBox: 'mob-day-cell-long-box', dayCellSmallBox: 'mob-day-cell-small-box',
    dayCellBox_MINE: 'mob-day-cell-box-mine', dayCellBox_TC: 'mob-day-cell-box-tc',
    dayCellBox_SS: 'mob-day-cell-box-ss', dayCellBox_OS: 'mob-day-cell-box-os',
    dayCellBox_VTO: 'mob-day-cell-box-vto',
    monthListContent: 'mob-month-list-content', monthListYear: 'mob-month-list-year',
    monthListMonth: 'mob-month-list-month',
    dailyManagerSettingGroupPanel: 'mob-daily-ms-group-panel',
    dailyManagerSettingPanel: 'mob-daily-ms-panel',
    dailyManagerSettingHeader: 'mob-daily-ms-header',
    dailyManagerSettingCollapse: 'mob-daily-ms-collapse',
    dailyManagerSettingName: 'mob-daily-ms-name',
    dailyManagerSettingAmountBox: 'mob-daily-ms-amount-box',
    amountBoxMyRequests: 'mob-amount-box-my-requests',
    amountBoxShifts: 'mob-amount-box-shifts', amountBoxPaycodes: 'mob-amount-box-paycodes',
    amountBoxTC: 'mob-amount-box-tc', amountBoxSS: 'mob-amount-box-ss',
    amountBoxOS: 'mob-amount-box-os', amountBoxVTO: 'mob-amount-box-vto',
    dailyManagerSettingShift: 'mob-daily-ms-shift',
    shiftCard: 'mob-shift-card',
    shiftCardTypeWrapper: 'mob-shift-card-type-wrapper',
    shiftCardType: 'mob-shift-card-type', statusLabel: 'mob-status-label',
    topBar: 'mob-top-bar', topBarAppName: 'mob-top-bar-app-name',
    buttonTopBar: 'mob-button-top-bar', topBarExit: 'mob-top-bar-exit',
    topBarMenu: 'mob-top-bar-menu', topBarMenuItem: 'mob-top-bar-menu-item',
    topBarNameSection: 'mob-top-bar-name-section',
    filterTitle: 'mob-filter-title', filterItem: 'mob-filter-item',
    listViewItem: 'mob-list-view-item',
    listViewDayOfTheWeek: 'mob-list-view-day-of-week',
    listViewDate: 'mob-list-view-date',
    listViewBoxesArea: 'mob-list-view-boxes-area',
    listViewManagerSettingAmountBox: 'mob-list-view-ms-amount-box',
    historyItemContainer: 'mob-history-item-container',
    historyLogFirst: 'mob-history-log-first', historyLogName: 'mob-history-log-name',
    historyLogshiftTime: 'mob-history-log-shift-time',
    historyLogDate: 'mob-history-log-date',
    notificationsExit: 'mob-notifications-exit',
    notificationsExitButton: 'mob-notifications-exit-button',
    NotificationsTitle: 'mob-notifications-title',
    drawerPaper: 'mob-drawer-paper',
    chipTC: 'mob-chip-tc', chipSS: 'mob-chip-ss',
    chipOS: 'mob-chip-os', chipVTO: 'mob-chip-vto',
    badgeColor: 'mob-badge-color', buttonEllipsis: 'mob-button-ellipsis',
    bellIcon: 'mob-bell-icon', badgeSize: 'mob-badge-size',
    signUpIconSize: 'mob-signup-icon-size',
};

export default MOBILE_CLASSES;
